import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "house-lot-details-content"
}
const _hoisted_2 = {
  key: 0,
  class: "lots-details-wr"
}
const _hoisted_3 = { class: "container-select-lots" }
const _hoisted_4 = { class: "text-alert" }
const _hoisted_5 = { class: "lot-details-wr" }
const _hoisted_6 = { class: "content-row" }
const _hoisted_7 = { class: "value-row" }
const _hoisted_8 = { class: "content-row" }
const _hoisted_9 = { class: "value-row" }
const _hoisted_10 = { class: "content-row" }
const _hoisted_11 = { class: "value-row" }
const _hoisted_12 = { class: "content-row" }
const _hoisted_13 = { class: "value-row" }
const _hoisted_14 = {
  key: 1,
  class: "lots-details-wr"
}
const _hoisted_15 = { class: "container-warning" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "house-details-wr" }
const _hoisted_18 = { class: "price-total-wr" }
const _hoisted_19 = {
  key: 0,
  class: "total-wr"
}
const _hoisted_20 = { class: "total" }
const _hoisted_21 = {
  key: 1,
  class: "not-total"
}
const _hoisted_22 = {
  key: 2,
  class: "price-information"
}
const _hoisted_23 = { class: "buttons-content" }
const _hoisted_24 = {
  key: 1,
  class: "spinner small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.props.houseInfo && !$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title-home" }, "Home & Land Package", -1)),
          ($setup.lotSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, "Lot " + _toDisplayString($setup.lotSelected.title), 1),
                  _createElementVNode("div", {
                    class: "hipertext",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onCompareLots()))
                  }, "Change Lot")
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label-row" }, "Size", -1)),
                    _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatPrice($setup.lotSelected.size, false)) + " sqm", 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label-row" }, "Width", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.lotSelected.blockWidth ? `${$setup.formatPrice($setup.lotSelected.blockWidth, false)} m` : "Irregular"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label-row" }, "Registration", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.lotSelected.registrationDate ? $setup.formatDate($setup.lotSelected.registrationDate, "MMM YYYY") : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label-row" }, "Land Price", -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatPrice($setup.lotSelected.price)), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-alert" }, "No lot selected", -1)),
                  _createElementVNode("img", {
                    class: "icon-warning",
                    src: require('@/assets/icons/icon-warning.svg')
                  }, null, 8, _hoisted_16)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-information" }, "Please select a lot to complete your home and land package.", -1)),
                _createElementVNode("div", {
                  class: "button default primary compare",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onCompareLots()))
                }, "Compare suitable lots")
              ])),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "line-one" }, null, -1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode($setup["HouseDetailsForLandPackage"], {
              houseInfo: $setup.props.houseInfo,
              siteCosts: $setup.siteCosts
            }, null, 8, ["houseInfo", "siteCosts"])
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "line" }, null, -1)),
          _createElementVNode("div", _hoisted_18, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-package" }, "Package Price", -1)),
            ($setup.lotSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "from" }, "From", -1)),
                  _createElementVNode("div", _hoisted_20, _toDisplayString($setup.TotalPriceWithFacade), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, "Select your lot"))
          ]),
          ($setup.lotSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, "*Terms & Conditions apply. Build price subject to change prior to entry into the Contract."))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "button default primary chat",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onMessage()))
            }, "Get in touch with " + _toDisplayString($setup.props.builder.name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["button default primary hold", { disabled: !$setup.lotSelected }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onReserve()))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["title-button", { 'color-text': !$setup.lotSelected }])
              }, "Reserve Lot " + _toDisplayString($setup.lotSelected?.lotId?.title), 3)
            ], 2)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_24)),
    _createVNode($setup["BuilderLotsMapModal"], {
      isOpen: $setup.openLotsModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.openLotsModal = false)),
      onSend: $setup.onSelectLot,
      lotsByHouseDesigns: $setup.lotsByHouseDesigns,
      estateInfo: $setup.props.estateInfo
    }, null, 8, ["isOpen", "lotsByHouseDesigns", "estateInfo"]),
    ($setup.shouldRenderModals)
      ? (_openBlock(), _createBlock($setup["BuilderEnquiryModal"], {
          key: 2,
          isOpen: $setup.isOpenedModalMessage,
          lot: $setup.lotSelected,
          house: $setup.props.houseInfo,
          quote: $setup.props.quote,
          estate: $setup.props.estateInfo,
          builder: $setup.props.builder,
          selectedFacade: $props.selectedFacade,
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.isOpenedModalMessage = false)),
          onSend: $setup.onSendBuilderEnquiry
        }, null, 8, ["isOpen", "lot", "house", "quote", "estate", "builder", "selectedFacade"]))
      : _createCommentVNode("", true),
    ($setup.shouldRenderModals)
      ? (_openBlock(), _createBlock($setup["BuilderInitialHoldModal"], {
          key: 3,
          "is-open": $setup.isOpenedModalReserve,
          lot: $setup.lotSelected,
          house: $setup.props.houseInfo,
          quote: $setup.props.quote,
          estate: $setup.props.estateInfo,
          builder: $setup.props.builder,
          selectedFacade: $props.selectedFacade,
          onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.isOpenedModalReserve = false)),
          onSend: $setup.onSendSecureQuote,
          onBack: _cache[7] || (_cache[7] = ($event: any) => ($setup.isOpenedModalReserve = false))
        }, null, 8, ["is-open", "lot", "house", "quote", "estate", "builder", "selectedFacade"]))
      : _createCommentVNode("", true),
    _createVNode($setup["SuccessRequestReserveModal"], {
      isOpen: $setup.successfulRequestReserveOpened,
      onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.successfulRequestReserveOpened = false)),
      house: $setup.props.houseInfo
    }, null, 8, ["isOpen", "house"])
  ], 64))
}